import { useState } from 'react';

/**
 * A section editor's initial form: what `build` returns on the first render where `ready` holds, kept after that, so
 * a refetch of the record, the ones around a save included, does not reset the fields being edited. `undefined` until
 * then.
 */
export const useFrozenOnceLoaded = <T>(ready: boolean, build: () => T): T | undefined => {
    const [frozen, setFrozen] = useState<{ value: T }>();
    if (!frozen && ready) {
        setFrozen({ value: build() });
    }
    return frozen?.value;
};
